import MSpecificNumberSetting from './index.vue';

MSpecificNumberSetting.install = app => {
  app.component(MSpecificNumberSetting.name, MSpecificNumberSetting);
};

export default MSpecificNumberSetting;
